import $ from 'jquery';

export default class GlobalElements {
    /**
     * Constructor.
     *
     * @return {Void}
     */
    constructor() {
        $(() => {
            $('.opb-global-elements-list').on('click', '.opb-delete-global-element-btn', this.handleGlobalElementDeleteClick);
        });
    }

    /**
     * Open confirm dialog and delete global element
     *
     * @param {Object} e
     * @return {Void}
     */
    handleGlobalElementDeleteClick(e) {
        e.preventDefault();
        let $btn         = $(e.currentTarget);
        let elementTitle = $btn.closest('.opb-global-element-list-item').find('.opb-global-element-title');
        let elementId    = $btn.data('gid');
        let deleteUrl    = $btn.attr('data-href') || $btn.attr('href');
        
        var deleteGlobalElementConfirm = window.OP3General.confirm(Object.assign(window.OP3General.dialogOptions, {
            title: elementTitle,
            content: `<p>Are you sure you want to delete this element?</p><p>If you delete a global element, and it is used somewhere on the page, it will be converted to a normal element.</p>`,
            buttons: {
                Yes: {
                    btnClass: 'btn-red',
                    action: () => {
                        deleteGlobalElementConfirm.showLoading(true);

                        /**
                         * AJAX request that deletes page in funnel
                         *
                         * @see GlobalElementsController@delete
                         */
                        $.ajax({
                            type: 'POST',
                            beforeSend: function(request) {
                                request.setRequestHeader("X-WP-Nonce", window.OpsScriptData.nonce);
                            },
                            url: deleteUrl,
                        }).success(function(response) {
                            $('.opb-global-element-list-item-' + elementId + '').fadeOut(function() {
                                $(this).remove();
                                // Check count
                                if ($('.opb-global-element-list-item').length < 1) {
                                    window.location.reload();
                                }
                            });
                            deleteGlobalElementConfirm.close();
                        }).error(function(response) {
                            deleteGlobalElementConfirm.setTitle('Error');
                            deleteGlobalElementConfirm.setContent(response.responseJSON.message);
                            deleteGlobalElementConfirm.hideLoading(true);
                        });
                        return false;
                    }
                }
            }
        }));
    }
}